var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.clickUpload}},[_vm._t("default"),_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","accept":_vm.accept,"id":_vm.id},on:{"change":_vm.showFiles}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }